import CloseIcon from "@mui/icons-material/Close";
import CreateIcon from "@mui/icons-material/Create";
import {
  Button,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { STEPS } from "../../constants/enums";
import { checkPermissions, toastMessage } from "../../helper";
import EmptyList from "../common/EmptyList";
import { emailLink } from "../../services/employeeService";
const EmployeeDetailedView = (props: any) => {
  const permissions = useSelector((state: any) => state.auth.userPermissions);
  const {
    employeeData,
    onClose,
    linkedBunits,
    controller,
    total_count,
    currentIndex,
    navigateNext,
    state,
    dispatch,
    dialCode,
  } = props;
  const { page, limit } = controller;
  const [step, setStep] = useState(STEPS.DETAILS);
  let index = limit * page + currentIndex;
  const navigate = useNavigate();
  let cellColumns = ["Unit Name", "Unit type", "Unit ID", "Incharge"];
  const [bunitsList, setBunitsList] = useState([] as any);

  const getKeyName = (val: any) => {
    switch (val) {
      case "email":
        return "Email Id";
        break;
      case "department":
        return "Department";
        break;
      case "employee_code":
        return "Employee code";
        break;
      case "mobile":
        return "Contact no.";
        break;
      case "address":
        return "Address";
        break;
      case "designation":
        return "Designation";
        break;
      default:
        break;
    }
  };
  const openEdit = () => {
    const userData = {
      name: employeeData?.display_name,
      email: employeeData?.email,
      phone: employeeData?.mobile,
      department: {
        value: employeeData?.department,
        label: employeeData?.department,
      },
      designation: employeeData?.designation,
      address: {
        addressLine1: employeeData?.address_line1,
        addressLine2: "",
        city: employeeData?.city,
        cityCode: employeeData?.city_code,
        state: employeeData?.state,
        stateCode: employeeData?.state_code,
        country: employeeData?.country,
        countryCode: employeeData?.country_code,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
      employeeCode: employeeData?.employee_code,
      profileImageUrl: employeeData?.profile_image_url,
      roleName: employeeData?.role_name,
      userId: employeeData?.userId,
      dialCode: employeeData?.dialCode,
    };
    const linkedBunitData = linkedBunits.map((each: any) => {
      return {
        ...each,
        value: each.business_unit,
        label: each.business_name,
      };
    });
    dispatch({
      type: "employeeDetailView",
      data: {
        userData: userData,
        linkedBunit: [...linkedBunitData],
        isEdit: true,
      },
    });
    navigate("/organisation/employee/edit-employee/" + userData.userId, {
      state: {
        userId: employeeData?.userId,
      },
    });
  };
  const onNavigateNext = (increment: number) => {
    if (increment > 0 && currentIndex === limit - 1) {
      navigateNext(increment, 1);
    } else if (increment < 0 && currentIndex === 0) {
      navigateNext(increment, -1);
    } else {
      navigateNext(increment, 0);
    }
  };
  const sendRegistrationLink = (userId: any) => {
    const employeeLinkObject = {
      userId: userId,
    };
    emailLink(employeeLinkObject)
      .then((res) => {
        toastMessage("Registration Link Resent", "success");
      })
      .catch((e) => {
        e?.response?.data?.message &&
          toastMessage(e?.response?.data?.message, "error");
      });
  };

  return (
    <div className="flex w-70 flex-col px-4 grow pw-detailed-view-main">
      {/* <div className="flex flex-row items-center"> */}
      <div className="flex flex-row items-center gap-6 p-2 px-4">
        <div className="pw-bunit-detailed-header w-full flex justify-end gap-3 pr-2">
          {checkPermissions(["UPDATE_EMPLOYEE"], permissions) ? (
            <Button onClick={openEdit} className="pw-editbox-emission">
              <CreateIcon className="pw-bunit-edit-icon text-neutral-600" />
              <div className="pw-edit">Edit</div>
            </Button>
          ) : (
            ""
          )}

          {index > 0 && (
            <div
              onClick={() => onNavigateNext(-1)}
              className="pw-navigate-next pw-padding-5"
            >
              <img src="assets/icons/prev.svg" alt=" " />
            </div>
          )}
          {index < total_count - 1 && (
            <div
              onClick={() => onNavigateNext(1)}
              className="pw-navigate-next pw-padding-5 pw-bunit-next"
            >
              <img src="assets/icons/next.svg" alt=" " />
            </div>
          )}

          <div
            onClick={() => onClose()}
            className="pw-navigate-next items-center"
          >
            <CloseIcon className=" items-center text-neutral-600" />
          </div>
        </div>
      </div>

      {step === STEPS.DETAILS && (
        <div className="flex flex-col pw-detail-main-content gap-5">
          <div className="flex flex-row gap-5">
            <img
              src={
                employeeData?.profile_image_url
                  ? employeeData.profile_image_url
                  : "assets/icons/account.svg"
              }
              alt=" "
              className="pw-bunit-detail-img"
            />
            <div className="flex flex-col justify-center grow">
              <div className="flex flex-row pw-border-bottom justify-between pb-2 pl-0.5 mb-2.5">
                <div className="flex">
                  <div
                    className="pw-bunit-detail-name text-xl font-semibold text-neutral-900"
                    id="pw-e2e-dv-employee-name"
                  >
                    {" "}
                    {employeeData.display_name}
                  </div>
                </div>

                <div>
                  {" "}
                  {employeeData.user_disabled ? (
                    <span className="pw-inactive-employee">InActive</span>
                  ) : employeeData.status === "RegisterRequest" ? (
                    // "Request Sent"
                    <div className="flex flex-row gap-2">
                      {checkPermissions(["CREATE_EMPLOYEE"], permissions) && (
                        <Button
                          onClick={() =>
                            sendRegistrationLink(employeeData.userId)
                          }
                          sx={{ textTransform: "none", cursor: "pointer" }}
                          variant="outlined"
                        >
                          Resend Link
                        </Button>
                      )}

                      <div
                        className="flex items-center justify-center"
                        id="pw-e2e-dv-employeecreation-status"
                      >
                        Request Sent
                      </div>
                    </div>
                  ) : (
                    <span className="pw-active-employee">Active</span>
                  )}
                </div>
              </div>

              <div className="flex flex-row items-center">
                <div
                  className="pw-bunit-incharge-content text-neutral-900 font-normal"
                  id="pw-e2e-dv-employee-role"
                >
                  {" "}
                  {employeeData.role_name === "Admin"
                    ? "Super user"
                    : employeeData.role_name}
                </div>
              </div>
            </div>
          </div>
          <div className="pw-bunit-detail-table pl-2">
            {Object.entries(employeeData).map(
              (obj: any[], index: number) =>
                index < 6 && (
                  <div
                    key={index}
                    className="flex flex-row pw-bdetail-item gap-3"
                  >
                    <div
                      style={{ whiteSpace: "nowrap" }}
                      className="w-1/6 text-neutral-600 text-sm"
                    >
                      {getKeyName(obj[0])}
                    </div>
                    <div
                      className="w-5/6 text-neutral-900 text-sm"
                      id={`e2e-dv-${getKeyName(obj[0])?.replace(/[ .]/g, "")}`}
                    >
                      {obj[0] === "mobile" && obj[1]?.length > 0
                        ? dialCode + " " + obj[1]
                        : obj[1] || "-"}
                    </div>
                  </div>
                )
            )}
          </div>
        </div>
      )}

      {linkedBunits?.length ? (
        <div className="flex flex-col pw-detail-main-content">
          <Card>
            <div className="flex pw-linked-facility pb-5">
              Linked Facilities
            </div>
            <Table
              size="small"
              className="pw-bunit-table pw-emission-table-container mb-5"
            >
              <TableHead className="pw-blist-head bg-neutral-50">
                <TableRow className="h-14">
                  {cellColumns.map((eachCell, index) => (
                    <TableCell
                      key={index}
                      className={`pw-thead-list ${
                        eachCell === "Status" ? "text-" : ""
                      }`}
                    >
                      {eachCell}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {linkedBunits?.map((eachBUnit: any, index: number) => (
                  <TableRow
                    key={eachBUnit.association_id}
                    className={` ${
                      eachBUnit.selected ? "bg-primary-100" : "bg-white"
                    } h-14`}
                  >
                    <TableCell className="pw-e2e-dv-facility-name">
                      {eachBUnit.business_name}
                    </TableCell>
                    <TableCell
                      id={
                        eachBUnit.business_name
                          ? `pw-e2e-dv-${eachBUnit.business_name.replace(
                              /[ .@]/g,
                              ""
                            )}-type`
                          : ""
                      }
                    >
                      {eachBUnit.business_type || "-"}
                    </TableCell>
                    <TableCell
                      id={
                        eachBUnit.business_name
                          ? `pw-e2e-dv-${eachBUnit.business_name.replace(
                              /[ .@]/g,
                              ""
                            )}-id`
                          : ""
                      }
                    >
                      {eachBUnit.business_id || "-"}
                    </TableCell>
                    <TableCell
                      id={
                        eachBUnit.business_name
                          ? `pw-e2e-dv-${eachBUnit.business_name.replace(
                              /[ .@]/g,
                              ""
                            )}-incharge`
                          : ""
                      }
                    >
                      {eachBUnit.business_incharge}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Card>
        </div>
      ) : (
        <EmptyList cellColumns={cellColumns} />
      )}
    </div>
  );
};

export default EmployeeDetailedView;
